
import type { ISODateTime } from '../types/api';

const RENEW_BEFORE_EXPIRY_MS = 5 * 60_000;
const MIN_RENEW_INTERVAL_MS = 60_000;

export function renewDelayMs(expiresAt: ISODateTime | undefined): number | false {
  if (!expiresAt) return false;
  const msLeft = Date.parse(expiresAt) - Date.now();
  if (!Number.isFinite(msLeft)) return false;
  return Math.max(MIN_RENEW_INTERVAL_MS, msLeft - RENEW_BEFORE_EXPIRY_MS);
}
